"use strict";
//@ts-check
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.kw_exported = exports.stack = exports.concatenate = exports.swapAxes = exports.transpose = exports.sort = exports.cmp_nan_at_the_end = exports.apply_along_axis = void 0;
var basic_1 = require("./basic");
var js_interface_1 = require("./js-interface");
var utils_js_1 = require("../utils-js");
var kwargs_1 = require("./kwargs");
var dtypes_1 = require("../dtypes");
/**
 * This function can reduce, sort, operate pointwise, or increase the dimensionality.
 */
function apply_along_axis(arr, axis, transform, dtype) {
    if (dtype === void 0) { dtype = Float64Array; }
    arr = (0, basic_1.asarray)(arr);
    if (axis == null)
        return transform(arr.flat);
    var nDims = arr.shape.length;
    if (axis < 0)
        axis = nDims + axis;
    if (axis !== nDims - 1) {
        // Transpose to end, apply, and transpose back:
        var tmp_1 = swapAxes(arr, axis, -1);
        var out_1 = apply_along_axis(tmp_1, -1, transform, dtype);
        //@ts-ignore
        return swapAxes(out_1, axis, -1);
    }
    var m = arr.shape[axis];
    var shift = (0, basic_1.shape_shifts)(arr.shape)[axis];
    var groups = Array.from({ length: m }, function (_) { return []; });
    arr.flat.forEach(function (value, i) { return groups[(Math.floor(i / shift)) % m].push(value); });
    // Transpose it:
    var nCols = arr.size / m;
    var groupsT = [];
    for (var j = 0; j < nCols; j++) {
        var newRow = [];
        for (var i = 0; i < m; i++)
            newRow.push(groups[i][j]);
        groupsT.push(newRow);
    }
    var data = groupsT.map(transform);
    var tmp = (0, js_interface_1.fromlist)(data);
    var shape = __spreadArray(__spreadArray(__spreadArray([], __read(arr.shape.slice(0, axis)), false), __read(tmp.shape.slice(1)), false), __read(arr.shape.slice(axis + 1)), false);
    var out = (0, basic_1.new_NDArray)((0, dtypes_1.new_buffer)(tmp.flat, dtype), shape);
    return (0, basic_1.number_collapse)(out);
}
exports.apply_along_axis = apply_along_axis;
var cmp_nan_at_the_end = function (a, b) {
    // https://stackoverflow.com/a/56265258/3671939
    //@ts-ignore
    return a - b || isNaN(a) - isNaN(b) || Object.is(b, -0) - Object.is(a, -0);
};
exports.cmp_nan_at_the_end = cmp_nan_at_the_end;
function sort(a, axis) {
    return apply_along_axis(a, axis, function (arr) {
        var cpy = __spreadArray([], __read(arr), false);
        cpy.sort(exports.cmp_nan_at_the_end);
        return cpy;
    }, a.dtype);
}
exports.sort = sort;
function transpose(arr, axes) {
    var _a;
    if (axes === void 0) { axes = null; }
    (axes = Object.assign({ axes: axes }, this).axes);
    //@ts-ignore
    if (axes !== null && axes["axes"])
        (_a = axes, axes = _a.axes);
    var nDims = arr.shape.length;
    if (axes == null)
        return transpose(arr, Array.from({ length: nDims }, function (_, i) { return i; }).reverse());
    if (axes.length !== nDims)
        throw new Error("Axes must have length ".concat(nDims, ". Found ").concat(axes.length));
    var inv = Array.from({ length: nDims }, function () { return -1; });
    for (var i = 0; i < nDims; i++) {
        if (axes[i] < 0 || axes[i] >= nDims)
            throw new Error("Expected axis in [0..".concat(nDims, "). Found ").concat(axes[i]));
        inv[axes[i]] = i;
    }
    for (var i = 0; i < nDims; i++)
        if (inv[i] == -1)
            throw new Error("Axes must contain all dimensions. [".concat(axes.join(", "), "] is missing ").concat(i, "."));
    var srcShifts = (0, basic_1.shape_shifts)(arr.shape);
    var shape = axes.map(function (j) { return arr.shape[j]; });
    var shifts = axes.map(function (j) { return srcShifts[j]; });
    // Copied from slice:
    var indices = [];
    var tuple = new Array(shape.length).fill(0);
    var cursor = 0;
    while (true) {
        if (!isFinite(cursor))
            throw new Error("Programming error");
        indices.push(cursor);
        var axis = nDims - 1;
        while (axis >= 0) {
            tuple[axis]++;
            cursor += shifts[axis];
            if (tuple[axis] < shape[axis])
                break;
            // Overflow
            cursor -= shifts[axis] * shape[axis];
            tuple[axis] = 0;
            axis--;
        }
        ;
        if (axis < 0)
            break;
    }
    // Now, just copy the data:
    var src = arr.flat;
    return (0, basic_1.new_NDArray)(arr.dtype.from(indices.map(function (i) { return src[i]; })), shape);
}
exports.transpose = transpose;
function swapAxes(arr, axisA, axisB) {
    arr = (0, basic_1.asarray)(arr);
    var nDims = arr.shape.length;
    if (axisA < 0)
        axisA = nDims + axisA;
    if (axisB < 0)
        axisB = nDims + axisB;
    var perm = Array.from({ length: nDims }, function (_, i) { return i; });
    perm[axisA] = axisB;
    perm[axisB] = axisA;
    return transpose(arr, perm);
}
exports.swapAxes = swapAxes;
function concatenate(arrays, axis) {
    var _a, e_1, _b;
    if (axis === void 0) { axis = null; }
    // ({ axis } = Object.assign({ axis }, this));
    //@ts-ignore
    if (axis instanceof Object)
        (_a = axis, axis = _a.axis);
    if ((0, basic_1.isarray)(arrays))
        arrays = __spreadArray([], __read(arrays), false);
    arrays = arrays.map(basic_1.asarray);
    if (axis == null) {
        arrays = arrays.map(function (arr) { return (0, basic_1.ravel)(arr); });
        axis = 0;
    }
    if (!arrays.length)
        throw new Error("Expected at least two arrays");
    var nDims = arrays[0].shape.length;
    if (axis < 0)
        axis = nDims + axis;
    var shapeIn = __spreadArray([], __read(arrays[0].shape), false);
    var flat = [];
    var shape = shapeIn.map(function (_, i) { return i == 0 ? 0 : shapeIn[i == axis ? 0 : i]; });
    try {
        for (var arrays_1 = __values(arrays), arrays_1_1 = arrays_1.next(); !arrays_1_1.done; arrays_1_1 = arrays_1.next()) {
            var arr = arrays_1_1.value;
            if (!(0, utils_js_1.allEq)(arr.shape.filter(function (_, i) { return i != axis; }), shapeIn.filter(function (_, i) { return i != axis; })))
                throw new Error("Inconsistent input shape ".concat(shapeIn, " with respect to ").concat(arr.shape.map(function (v, i) { return i == axis ? '?' : v; })));
            shape[0] += arr.shape[axis];
            arr = axis == 0 ? arr : swapAxes(arr, axis, 0);
            (0, utils_js_1.extend)(flat, arr.flat);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (arrays_1_1 && !arrays_1_1.done && (_b = arrays_1.return)) _b.call(arrays_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    // TO DO: infer or expect dtype here:
    var dtype = dtypes_1.dtype_least_ancestor.apply(void 0, __spreadArray([], __read(arrays.map(function (arr) { return arr.dtype; })), false));
    var out = (0, basic_1.new_NDArray)(dtype.from(flat), shape);
    if (axis == 0)
        return out;
    else
        return swapAxes(out, axis, 0);
}
exports.concatenate = concatenate;
function stack(arrays, axis) {
    var _a, e_2, _b;
    if (axis === void 0) { axis = 0; }
    //@ts-ignore
    if (axis instanceof Object)
        (_a = axis, axis = _a.axis);
    if ((0, basic_1.isarray)(arrays))
        arrays = __spreadArray([], __read(arrays), false);
    if (!Array.isArray(arrays))
        throw new Error("Expected list of arrays. Found ".concat(typeof arrays));
    arrays = arrays.map(basic_1.asarray);
    if (!arrays.length)
        throw new Error("Expected at least two arrays");
    var shapeIn = __spreadArray([], __read(arrays[0].shape), false);
    if (axis < 0)
        axis = shapeIn.length + 1 + axis;
    var shapeBroadcast = __spreadArray(__spreadArray(__spreadArray([], __read(shapeIn.slice(0, axis)), false), [1], false), __read(shapeIn.slice(axis)), false);
    var bArrays = [];
    try {
        for (var arrays_2 = __values(arrays), arrays_2_1 = arrays_2.next(); !arrays_2_1.done; arrays_2_1 = arrays_2.next()) {
            var arr = arrays_2_1.value;
            if (!(0, utils_js_1.allEq)(arr.shape, shapeIn)) {
                throw new Error("Inconsistent input shape ".concat(JSON.stringify(shapeIn), " with respect to ").concat(JSON.stringify(arr.shape)));
            }
            bArrays.push((0, basic_1.reshape)(arr, shapeBroadcast));
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (arrays_2_1 && !arrays_2_1.done && (_b = arrays_2.return)) _b.call(arrays_2);
        }
        finally { if (e_2) throw e_2.error; }
    }
    return concatenate(bArrays, axis);
}
exports.stack = stack;
exports.kw_exported = {
    sort: kwargs_1.Func_a_lastAxis.defaultDecorator(sort),
};
